import Vue                  from "vue";
import { accountRouter }    from "./router";
import { mapState }         from "vuex";
import checkoutStore        from "./store/index.js";
import Notifications        from 'vue-notification';
import VueI18n              from 'vue-i18n';
import checkoutTranslations from './translations.js';
import axios                from 'axios';
import {
    setInteractionMode,
    ValidationObserver,
    ValidationProvider,
    extend
}                           from 'vee-validate';
import { required, email }  from "vee-validate/dist/rules";

Vue.use(VueI18n);
Vue.use(Notifications);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('extend', extend);

window.axios = axios;
window.axios.defaults.headers.common['Accept'] = 'application/json';

// Import the project CSS
import '../../../../../src/css/app-base.pcss';
import '../../../../../src/css/app-components.pcss';
import '../../../../../src/css/app-utilities.pcss';
import '../css/styles.pcss';

const i18n = new VueI18n({
    messages: checkoutTranslations
});

i18n.locale = 'nl';
window.i18n = i18n;

setInteractionMode('eager');

extend('required', {
    ...required,
    message: (_, values) => i18n.t("validation.required", values)
});

extend('email', {
    ...email,
    message: (_, values) => i18n.t("validation.email", values)
});

const account = new Vue({
    el: '#account',
    delimiters: ['${', '}'],
    
    store: checkoutStore,
    router: accountRouter,
    i18n,
    
    components: {
        'account-dashboard': () => import(/* webpackChunkName: "account-dashboard" */ '../components/account/AccountDashboard.vue'),
        'modal-container': () => import(/* webpackChunkName: "modal-container" */ '../components/components/ModalContainer.vue')
    },
    
    created() {
        this.$store.dispatch('shipping/loadEnabledCountries');
    },
    
    mounted() {
        // Set siteUrl
        const siteUrl = document.head.querySelector('meta[name="site-url"]')
        if (siteUrl) {
            this.$store.dispatch('saveSiteUrl', siteUrl.content);
        } else {
            console.error('siteUrl not found.')
        }
        
        // Set CSRF token
        const csrfToken = document.head.querySelector('meta[name="csrf-token"]')
        if (csrfToken) {
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
        } else {
            console.error('CSRF token not found.')
        }
    
        // Set language
        window.rootUrl = '/';
        const language = document.head.querySelector('meta[name="language"]')
        if (language) {
            window.language = language.content;
            this.$i18n.locale = language.content;
            window.rootUrl = window.language !== 'nl' ? '/en/' : '/';
        } else {
            console.error('language not found.')
        }
    },
    
    computed: {
        ...mapState({
            showModal: state => state.showModal,
            modalData: state => state.modalData
        })
    }
})
